import getComponent from './get-component';

const getCommonConstants = () => {
  const component = getComponent();
  return component.getCommonConstants();
};

export default getCommonConstants;
